import { memo, useState } from 'react'

import { useFetchFilters, useFetchJobTitles } from '../../api/apiHooks'
import { Filter } from './Filter'
import { FilterWithSearching } from './FilterWithSearching'
import { SearchFilter } from './SearchFilter'
import { Sorting } from './Sorting'

const Filters: React.FC = memo(() => {
  const [jobTitleInputValue, setJobTitleInputValue] = useState<string>('')

  const { data } = useFetchFilters()
  console.log('data', data)
  const jobTitles = useFetchJobTitles(jobTitleInputValue.trim())

  const sortingOptions = ['Oldest', 'Most usage']

  const fetchNextJobTitles = () => {
    void jobTitles.fetchNextPage()
  }

  const typeOptions = ['Digital Twin', 'Synthetic']

  return (
    <div className="tc-mv-admin-filters-wrapper">
      <div className="-z-10 absolute bottom-0 left-0 right-0 tc-mv-blur top-0" />
      <div className="tc-mv-admin-filters-container">
        <div className="tc-mv-admin-filter-item">
          <SearchFilter />
        </div>
        <div className="tc-mv-admin-filter-item">
          <Filter
            label="Filter by companion type"
            options={typeOptions}
            defaultOption="All Types"
            filterBy="search_mode"
          />
        </div>
        <div className="tc-mv-admin-filter-item">
          <FilterWithSearching
            label="Filter by job title or position"
            defaultOption="All Titles"
            filterBy="jobTitle"
            hasNextPage={jobTitles.hasNextPage}
            fetchNextPage={fetchNextJobTitles}
            data={jobTitles.data}
            isFetchingNextPage={jobTitles.isFetchingNextPage}
            isFetching={jobTitles.isFetching}
            setInputValue={setJobTitleInputValue}
            queryKey="get-job-titles"
          />
        </div>
        <div className="tc-mv-admin-filter-item">
          <Filter
            label="Filter by industry or sector"
            options={data?.industry || []}
            defaultOption="All Industries"
            filterBy="industry"
          />
        </div>
        <div className="tc-mv-admin-filter-item">
          <Filter
            label="Filter by gender identity"
            options={data?.gender || []}
            defaultOption="All Genders"
            filterBy="gender"
          />
        </div>
        <div className="tc-mv-admin-filter-item">
          <Filter
            label="Filter by racial or ethnic background"
            options={data?.race || []}
            defaultOption="All Races"
            filterBy="race"
          />
        </div>
        <div className="tc-mv-admin-filter-item">
          <Sorting
            label="Sort by"
            options={sortingOptions}
            defaultOption="Newest"
          />
        </div>
      </div>
    </div>
  )
})

export { Filters }
